<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="5000" style="z-index: 10000;">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center pt-4>
      <v-flex xs12>
        <v-layout row justify-space-between align-center px-2>
          <v-flex xs12 sm6 md6 lg6 xl6>
            <span class="heading">Resources</span>
          </v-flex>
          <v-flex xs12 sm6 md6 lg6 xl6 pt-2 pt-lg-0 pt-sm-0 pt-md-0 class="text-right">
            <v-btn color="#f58120" @click="addResourceDialog = true">
              <span style="font-size: 12px; font-family: poppinssemibold; color: white;">
                Add Resource
                <v-icon color="white">mdi-plus</v-icon>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 mt-4>
        <v-tabs v-model="activeTab" background-color="transparent" color="#427D2D">
          <v-tab>Images</v-tab>
          <v-tab>Videos</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" style="background-color: transparent;">
          <v-tab-item eager>
            <ImageList ref="imageListRef" :hideHeader="true" />
          </v-tab-item>
          <v-tab-item eager>
            <VideoList ref="videoListRef" :hideHeader="true" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>

    <!-- Add Resource Dialog -->
    <v-dialog v-model="addResourceDialog" max-width="700px">
      <v-card rounded="lg">
        <v-card-title>
          <span class="heading">Add resources</span>
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="addResourceDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs v-model="activeAddTab" centered color="#427D2D">
          <v-tab>Add Image</v-tab>
          <v-tab>Add Video</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeAddTab">
          <v-tab-item>
            <AddImageForm @success="onAddSuccess" @show-msg="onShowMsg" />
          </v-tab-item>
          <v-tab-item>
            <AddVideoForm @success="onAddSuccess" @show-msg="onShowMsg" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImageList from "../Images/imageList.vue";
import VideoList from "../Videos/videoList.vue";
import AddImageForm from "./AddImageForm.vue";
import AddVideoForm from "./AddVideoForm.vue";

export default {
  components: {
    ImageList,
    VideoList,
    AddImageForm,
    AddVideoForm,
  },
  data() {
    return {
      activeTab: 0,
      activeAddTab: 0,
      addResourceDialog: false,
      showSnackBar: false,
      msg: "",
    };
  },
  watch: {
    addResourceDialog(val) {
      if (val) {
        // Sync the add modal tab with the current active list tab
        this.activeAddTab = this.activeTab;
      }
    }
  },
  methods: {
    onShowMsg(msg) {
      this.msg = msg;
      this.showSnackBar = true;
    },
    onAddSuccess(msg) {
      this.msg = msg;
      this.showSnackBar = true;
      this.addResourceDialog = false;
      
      // Refresh the active tab
      if (this.activeAddTab === 0) {
        // Image was added
        this.activeTab = 0;
        if (this.$refs.imageListRef && this.$refs.imageListRef.getData) {
          this.$refs.imageListRef.getData();
        }
      } else {
        // Video was added
        this.activeTab = 1;
        if (this.$refs.videoListRef && this.$refs.videoListRef.getData) {
          this.$refs.videoListRef.getData();
        }
      }
    }
  }
};
</script>

<style scoped>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
</style>
